import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { AgentNodeForm } from "src/agentNode/types";
import { Card } from "src/base-components/Card";
import { AutocompleteCodeInput } from "src/base-components/CodeInput/EditorCodeInput";

type Props = {
  immutable: boolean;
};

export const AgentResponseMapping: React.FC<Props> = ({ immutable }) => {
  const { control } = useFormContext<AgentNodeForm>();

  return (
    <div className="flex flex-col gap-y-2">
      <span className="text-gray-800 font-inter-semibold-13px">Output</span>
      <Card variant="default">
        <Card.Content>
          <div className="flex flex-col gap-y-2">
            <p className="text-gray-500 font-inter-normal-12px">
              Agent response will be saved to:
            </p>
            <Controller
              control={control}
              name="response.default.mapped_to"
              render={({ field }) => (
                <AutocompleteCodeInput
                  dataLoc="agent-response-mapping"
                  disabled={immutable}
                  placeholder="agent_response"
                  prefix="data."
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};
